function CanceledRequestError() {
  this.$canceledRequestError = true; // Needed due to use in workers
  this.name = 'Cancelled Request Error';
  this.message = 'This request was cancelled in the browser.';

  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
  this.stack = new Error().stack;
}

CanceledRequestError.prototype = Object.create(Error.prototype);
CanceledRequestError.prototype.constructor = CanceledRequestError;

export default CanceledRequestError;
